// const API = "http://localhost:3000/";
const API = "https://database-secondhand.onrender.com/";

export const get = async (path) => {
  const res = await fetch(API + path);
  return res.json();
};

export const post = async (path, data) => {
  const response = await fetch(API + path, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const res = await response.json();
  return res;
};

export const patch = async (path, data) => {
  const response = await fetch(API + path, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const res = await response.json();
  return res;
};

// PUT request
export const put = async (path, data) => {
  const response = await fetch(API + path, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`PUT request lỗi: ${response.status}`);
  }

  const res = await response.json();
  return res;
};
